import { WORK_TYPE_COLORS } from '../views/scheduleUtils'

export const COLORS = WORK_TYPE_COLORS
// 범위(1주/2주/월/전체) 세그먼트 — 현장 미선택/선택 두 툴바에서 공유
export const GANTT_PERIOD_OPTIONS = (['1주', '2주', '월', '전체'] as const).map(v => ({ label: v, value: v }))
// 미지정(커스텀 라벨 직접 입력)일 때의 기본 마커 색 — milestoneType이 null이거나
// 알려진 코드가 아닐 때 이 색으로 표시된다 ('OTHER' 코드 자체는 더 이상 쓰지 않는다).
export const MILESTONE_DEFAULT_COLOR = 'var(--shell-on-surface-2)'
export const MILESTONE_COLORS: Record<string, string> = {
  MOVE_IN:         'var(--gt-primary)',
  PARTIAL_PAYMENT: 'var(--color-info)',
  COMPLETION:      'var(--color-successStrong)', // 글자색으로도 쓰임 — AA 대비
  INSPECTION:      'var(--indipia-purple-600)', // 대응 status 토큰 없음 — ΔE 최근접 primitive(구 보라 hex)
}
// PDF 인쇄 창(about:blank)에 복사할 토큰 — 인쇄 HTML·MILESTONE_COLORS 가 참조하는 것만.
export const PRINT_TOKEN_VARS = [
  '--shell-bg', '--shell-surface', '--shell-border', '--shell-on-surface', '--shell-on-surface-2', '--shell-hint',
  '--gt-primary', '--gt-subtle', '--gt-on-primary', '--color-error', '--color-info', '--color-successStrong',
  '--alpha-black-50', '--indipia-purple-600', '--status-danger-600', '--status-info-600',
]
// 새 마일스톤 추가 시 칩으로 우선 노출할 "자주 쓰는 유형" — BE 공통코드 응답이 아직
// 없을 때(로딩 중 등)를 대비한 기본 한글명도 함께 둔다.
export const FREQUENT_MILESTONE_TYPES = ['MOVE_IN', 'PARTIAL_PAYMENT', 'COMPLETION', 'INSPECTION'] as const
export const DEFAULT_MILESTONE_TYPE_NAMES: Record<string, string> = {
  MOVE_IN:         '입주일',
  PARTIAL_PAYMENT: '중도금',
  COMPLETION:      '공사완료',
  INSPECTION:      '검사일',
}
export const DN     = ['일','월','화','수','목','금','토']
export const PDF_DW = 36
export const BUFFER_DAYS = 10  // 팬 모드 부드러운 스크롤을 위한 좌우 여분 컬럼 수
// 1주/2주/월/전체 뷰 모두, 실제로 보여주는 시작·끝 날짜 앞뒤로 이만큼 더 보여준다
export const EXTRA_PAD_DAYS = 3
// 간트 앞쪽 여유 — 제일 먼저 시작하는 공정(표시 기간 시작)보다 2주 앞부터 보여준다. 끌어 옮길 수 있는 범위도 여기까지(A-11)
export const LEAD_PAD_DAYS = 14
export const RH = 36